import React from 'react';
import styled, { keyframes } from 'styled-components/macro';
import { fadeIn } from '../styling/animations';
import { colourPrimarySeaGreen } from '../styling/colours';

type Props = {
  size: number;
  colour: string;
  className?: string;
};

export const loadingIndicatorTestId = 'loading-indicator';

export const LoadingIndicator = (props: Props) => (
  <SpinnerContainer $size={props.size * 5} data-testid={loadingIndicatorTestId} className={props.className}>
    {delays.map((delay, index) => (
      <Rectangle key={index} $widthInPixels={props.size} $animationDelayInSeconds={delay} $colour={props.colour} />
    ))}
  </SpinnerContainer>
);

const delays = [0, -1.1, -1.0, -0.9, -0.8];

const stretchDelay = keyframes`
  0%, 40%, 100% { 
    opacity: 1;
    transform: scaleY(0.25);
  }  20% { 
    opacity: 0.8;
    transform: scaleY(1.0);
  }
`;

const SpinnerContainer = styled.div<{ $size: number }>`
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  display: inline-block;
`;

const Rectangle = styled.div<{ $animationDelayInSeconds: number; $widthInPixels: number; $colour: string }>`
  background-color: ${props => props.$colour};
  height: 100%;
  width: ${props => props.$widthInPixels}px;
  display: inline-block;
  animation: ${stretchDelay} 1.2s infinite ease-in-out;
  animation-delay: ${props => props.$animationDelayInSeconds}s;
`;

export const pageLoadingIndicatorTestId = 'page-loading-indicator';

export const PageLoadingIndicator = () => (
  <PageLoadingIndicatorContainer data-testid={pageLoadingIndicatorTestId}>
    <LoadingIndicator colour={colourPrimarySeaGreen} size={10} />
  </PageLoadingIndicatorContainer>
);

const PageLoadingIndicatorContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 150px;
  animation: ${fadeIn} 0.5s ease-in both 0.15s;
`;
